import { useQuery } from "@tanstack/react-query";
import { api } from "./apiClient";

export const useRoles = () => {
  return useQuery({
    queryKey: ["roles"],
    queryFn: () => api.getRoles(),
  });
};
